import client from '@/api/base';

export default {
  async getProcessStatus() {
    const response = await client.get('coaching/leader/status/');
    return response;
  },

  async postProcessStatus(data) {
    const response = await client.post('coaching/leader/status/', data);
    return response;
  },

  async getJourney() {
    const response = await client.get('coaching/journey/');
    return response;
  },
};
